module.exports = __webpack_public_path__ + "static/media/game-stars-collection.d92e1362.png";